import React from 'react'
import { normalizeProps } from './utils/normalizeProps'

const CheckmarkCircleIcon = props => {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...normalizeProps(props)}
    >
      <path
        d='M2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16ZM22.7071 12.7071C23.0976 12.3166 23.0976 11.6834 22.7071 11.2929C22.3166 10.9024 21.6834 10.9024 21.2929 11.2929L14.5 18.0858L11.2071 14.7929C10.8166 14.4024 10.1834 14.4024 9.79289 14.7929C9.40237 15.1834 9.40237 15.8166 9.79289 16.2071L13.7929 20.2071C14.1834 20.5976 14.8166 20.5976 15.2071 20.2071L22.7071 12.7071Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default CheckmarkCircleIcon
